import React from "react";
import "./Future.sass";
import futureTop from "./../../../../assets/images/future-top.png";
import futureBottom from "./../../../../assets/images/future-bottom.png";

export default function Future() {
  return (
    <div className="future-container">
      <div className="future not-mobile">
        <div className="future-header">
          <div className="stars star-one">
            <img src="/images/stars.png" alt="stars" />
          </div>
          <div className="future-header-title">
            <h2>Future Direction</h2>
            <h3>TO THE METAVERSE AND BEYOND</h3>
            <h3>Timeline</h3>
          </div>
          <div className="stars star-two">
            <img src="/images/stars.png" alt="stars" />
          </div>
        </div>
        <div className="future-timeline">
          <div className="future-timeline-top">
            <h3>The Wage Cage War is Declared</h3>
            <h3>
              Verified Channels Open to Organize Battle Strategies. Normies Keep
              Out!
            </h3>
            <h3>The FrenDAO is formed- Welcome to the Halls of Amenti</h3>
            <h3>
              Uncle Elon’s Dream Machines are Fired Up! The degENGINE and
              frENGINE are ready to go!
            </h3>
            <h3>Exclusive TENDIES Auctions and Mints</h3>
          </div>
          <div className="future-timeline-map">
            <img src="/images/future-map.png" alt="map" />
          </div>
          <div className="future-timeline-bottom">
            <h3>
              1,777 First Edition Frens Enlist to Fight, equipped with a variety
              of Dank, Fresh and Spicy Memes
            </h3>
            <h3>17 Devine FrogGods are Auctioned</h3>
            <h3>Staking - Let the Games Begin! Good Boys get TENDIES</h3>
            <h3>MechaFrens join the Battle </h3>
            <h3>
              Fren Casino – Gamble all your TENDIES away like the degenerate you
              are!
            </h3>
          </div>
        </div>
      </div>
      <div className="future mobile">
        <img src={futureTop} alt="border Top" />
        <div className="future-content">
          <h2 className="future-title">Timeline</h2>
          <h2 className="future-subtitle">TO THE METAVERSE AND BEYOND</h2>
          <h4 className="future-number">1</h4>
          <h3 className="future-goal">The Wage Cage War is Declared</h3>
          <h4 className="future-number">2</h4>
          <h3 className="future-goal">
            1,777 First Edition Frens Enlist to Fight, equipped with a variety
            of Dank, Fresh and Spicy Memes
          </h3>
          <h4 className="future-number">3</h4>
          <h3 className="future-goal">
            Verified Channels Open to Organize Battle Strategies. Normies Keep
            Out!
          </h3>

          <h4 className="future-number">4</h4>
          <h3 className="future-goal">17 Devine FrogGods are Auctioned</h3>

          <h4 className="future-number">5</h4>
          <h3 className="future-goal">
            The FrenDAO is formed- Welcome to the Halls of Amenti
          </h3>

          <h4 className="future-number">6</h4>
          <h3 className="future-goal">
            Staking - Let the Games Begin! Good Boys get TENDIES
          </h3>

          <h4 className="future-number">7</h4>
          <h3 className="future-goal">
            Uncle Elon’s Dream Machines are Fired Up! The degENGINE and frENGINE
            are ready to go!
          </h3>

          <h4 className="future-number">8</h4>
          <h3 className="future-goal">MechaFrens join the Battle </h3>
          <h4 className="future-number">9</h4>
          <h3 className="future-goal">Exclusive TENDIES Auctions and Mints</h3>

          <h4 className="future-number">10</h4>
          <h3 className="future-goal">
            Fren Casino – Gamble all your TENDIES away like the degenerate you
            are!
          </h3>
        </div>
        <img src={futureBottom} alt="border Bottom" />
      </div>
    </div>
  );
}
